export enum printProfiles {
    QUALITY,
    PRODUCTION
}

export const printProfileStrings =
{
    0: "device.details.quality",
    1: "device.details.production"
}